const calculatePackagePricePPPW = (state, getters, includingDiscount) => {
  // this is the lead tenant calculation
  if (
    state.packagePrice.fullPriceAmount > 0 &&
    state.packagePrice.discountedPriceAmount > 0
  ) {
    return includingDiscount
      ? state.packagePrice.discountedPriceAmount
      : state.packagePrice.fullPriceAmount;
  } else if (state.products.length && state.accountInformation.guid === "") {
    const getOptionPrice = (option, includingDiscount) => {
      let value;

      if (!includingDiscount && option.price.old) {
        value = option.price.old;
      } else {
        value = option.price.current;
      }

      return value;
    };

    //const roundToNearest50p = price => Math.round(price / 50) * 50;
    const roundToWholeNumber = (price) => Math.round(price / 100) * 100;

    // Get the price without the broadband product included
    let price = getters.selectedProducts
      .filter((option) => option.type !== "Broadband")
      .map((option) => getOptionPrice(option, false))
      .reduce((total, price) => total + price, 0);

    // Add default BB pricing
    price += getOptionPrice(getters.defaultBroadbandProductOption, false);

    if (!getters.isDefaultBroadbandProductOptionSelected) {
      price +=
        getOptionPrice(getters.selectedBroadbandProductOption, false) -
        getOptionPrice(getters.defaultBroadbandProductOption, false);
    }

    if (includingDiscount && getters.hasUsedDiscount) {
      const discountDelta =
        getOptionPrice(getters.getDiscountedProductOption, false) -
        getOptionPrice(getters.getDiscountedProductOption, true);
      price -= discountDelta;
    }

    // Round this price
    //price = roundToNearest50p(price);

    //rounds to the nearest pound if £XX.99 or £XX.01
    let roundedPrice = roundToWholeNumber(price);
    if (roundedPrice > price && roundedPrice - price <= 1) {
      price = roundedPrice;
    } else if (roundedPrice < price && price - roundedPrice <= 1) {
      price = roundedPrice;
    }

    return price;
  } else {
    if (
      !includingDiscount &&
      !!state.accountInformation.nonDiscountedPppwPence
    ) {
      return state.accountInformation.nonDiscountedPppwPence;
    }

    // Discount will already be applied here if one was used.
    return state.accountInformation.pppwPence;
  }
};

export { calculatePackagePricePPPW };
